module.exports = __webpack_public_path__ + "static/media/icon-down-arrow-black.af41838b.svg";